import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { toast } from 'react-toastify';
import { getListWorkHourSummaryReport, exportListWorkHourSummaryReportCSV } from '../../../axios/Report/ReportUrlApi';
import { useAuth } from '../../../context/AuthContext'
import {
    ReportPageHeader,
    ReportDateFilterRow,
} from './ReportSharedComponents';
import dayjs from "dayjs";

const WorkHourSummaryReport = (props) => {
    const { onBack, setLoading, handleFilter, dataFilter, page, pageSize, getTabName, profile, isAdmin, totalPages } = props;
    const { genaralSettingDateFormat, genaralSettingTimeFormat, dateTimeFormat } = useAuth();

    const { t, i18n } = useTranslation()
    const currentLang = i18n.language;

    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);
    const initialFormData = {
        sumBy: "1",
        startDate: new Date(yesterday),
        endDate: new Date(yesterday),
        // endDate: endOfYear(new Date()),
        dropDownShowTime: 1,
        showTime: "h-m-s",
        groupByDevices: false,
        showEvents: false,
        showEventsRadio: "first-and-last"
    }

    const [formData, setFormData] = useState(initialFormData)

    // const handleInputChange = (e) => {
    //     const { name, value } = e.target;
    //     setFormData((prevData) => ({
    //         ...prevData,
    //         [name]: value,
    //     }));
    // }

    // const handleInputChange = (e) => {
    //     const { name, value } = e.target;

    //     if (name === 'sumBy') {
    //         let newStartDate = formData.startDate;
    //         let newEndDate = formData.endDate;
    //         let disableStart = false;
    //         let disableEnd = false;
    //         if (value === '1' || value === '5') {
    //             // Daily: luôn set startDate & endDate = hôm qua
    //             const yesterday = dayjs().subtract(1, 'day').toDate();
    //             newStartDate = yesterday;
    //             newEndDate = yesterday;
    //             disableStart = false;
    //             disableEnd = false;
    //         } else if (value === '2' && newStartDate) {
    //             // Weekly: +6 ngày
    //             newEndDate = dayjs(newStartDate).add(6, 'day').toDate();
    //             disableEnd = true;
    //         } else if (value === '4') {
    //             // Monthly: từ ngày 01 đến cuối tháng
    //             newStartDate = dayjs(newStartDate || new Date()).startOf('month').toDate();
    //             newEndDate = dayjs(newStartDate).endOf('month').toDate();
    //             disableStart = true;
    //             disableEnd = true;
    //         } else {
    //             // Cho phép chọn cả hai ngày
    //             disableStart = false;
    //             disableEnd = false;
    //         }

    //         setFormData((prevData) => ({
    //             ...prevData,
    //             [name]: value,
    //             startDate: newStartDate,
    //             endDate: newEndDate,
    //         }));


    //     } else if (name === 'startDate') {
    //         let newStartDate = value;
    //         let newEndDate = formData.endDate;

    //         if (formData.sumBy === '2') {
    //             // Nếu đang ở Weekly, tự động +6 ngày
    //             newEndDate = dayjs(newStartDate).add(6, 'day').toDate();

    //         } else if (formData.sumBy === '4') {
    //             // Nếu đang ở Monthly
    //             newStartDate = dayjs(newStartDate).startOf('month').toDate();
    //             newEndDate = dayjs(newStartDate).endOf('month').toDate();

    //         }

    //         setFormData((prevData) => ({
    //             ...prevData,
    //             startDate: newStartDate,
    //             endDate: newEndDate,
    //         }));
    //     } else if (name === 'endDate') {
    //         setFormData((prevData) => ({
    //             ...prevData,
    //             endDate: value,
    //         }));
    //     } else {
    //         setFormData((prevData) => ({
    //             ...prevData,
    //             [name]: value,
    //         }));
    //     }
    // };
    const handleInputChange = (e) => {
        const { name, value } = e.target;

        if (name === 'sumBy') {
            let newStartDate = formData.startDate;
            let newEndDate = formData.endDate;
            let disableStart = false;
            let disableEnd = false;

            if (value === '1') {
                // Daily: luôn chọn hôm qua
                const yesterday = dayjs().subtract(1, 'day').toDate();
                newStartDate = yesterday;
                newEndDate = yesterday;
                disableStart = false;
                disableEnd = false;
            } else if (value === '2') {
                // Weekly: từ hôm nay + 6 ngày
                const today = dayjs().subtract(7, 'day'); // ngày hiện tại
                newStartDate = today.toDate(); // nếu muốn newStartDate cũng là hôm nay
                newEndDate = today.add(6, 'day').toDate(); // end date = hôm nay + 6 ngày
                disableEnd = true;
            } else if (value === '4') {
                // Monthly: full tháng
                newStartDate = dayjs(newStartDate || new Date()).startOf('month').toDate();
                newEndDate = dayjs(newStartDate).endOf('month').toDate();
                disableStart = true;
                disableEnd = true;
            } else if (value === '5') {
                // Custom: giữ nguyên khoảng ngày hiện có
                disableStart = false;
                disableEnd = false;
            }

            setFormData((prevData) => ({
                ...prevData,
                sumBy: value,
                startDate: newStartDate,
                endDate: newEndDate,
            }));
        }
        else if (name === 'startDate') {
            let newStartDate = value;
            let newEndDate = formData.endDate;

            if (formData.sumBy === '2') {
                // Weekly: tự +6 ngày
                newEndDate = dayjs(newStartDate).add(6, 'day').toDate();

            } else if (formData.sumBy === '4') {
                // Monthly: từ ngày 01 đến cuối tháng
                newStartDate = dayjs(newStartDate).startOf('month').toDate();
                newEndDate = dayjs(newStartDate).endOf('month').toDate();

            } else {
                // Daily (1) & Custom (5): endDate = startDate
                newEndDate = newStartDate;
            }

            setFormData((prevData) => ({
                ...prevData,
                startDate: newStartDate,
                endDate: newEndDate,
            }));
        } else if (name === 'endDate') {
            let newEndDate = value;

            // Không cho endDate < startDate
            if (formData.startDate && dayjs(newEndDate).isBefore(dayjs(formData.startDate), 'day')) {
                newEndDate = formData.startDate;
            }

            setFormData((prevData) => ({
                ...prevData,
                endDate: newEndDate,
            }));
        } else {
            // ⬅️ các field còn lại như showTime
            setFormData((prevData) => ({
                ...prevData,
                [name]: value,
            }));
        }

    };

    function formatDateTime(date) {
        const yyyy = date.getFullYear();
        const MM = String(date.getMonth() + 1).padStart(2, '0');
        const dd = String(date.getDate()).padStart(2, '0');
        const hh = String(date.getHours()).padStart(2, '0');
        const mm = String(date.getMinutes()).padStart(2, '0');
        const ss = String(date.getSeconds()).padStart(2, '0');

        return `${yyyy}-${MM}-${dd} ${hh}:${mm}:${ss}`;
    }

    //     const bodyRequest = {
    //     "reportCycleTypeId": 4,
    //     "fromDate": "2025-01-27",
    //     "toDate": "2025-01-27",
    //     "userId": null,
    //     "userTypeId": null,
    //     "shiftId": 4001,
    //     "groupId": null,
    //     "pageNo": 1,
    //     "recordPerPage": 10,
    //     "showTime": formData.showTime
    // }


    const bodyRequest = {
        "reportCycleTypeId": formData?.sumBy ? Number(formData.sumBy) : 1,
        "fromDate": formData.startDate?.target?.value
            ? formatDateTime(formData.startDate.target.value)
            : formatDateTime(formData.startDate),
        "toDate": formData.endDate?.target?.value
            ? formatDateTime(formData.endDate.target.value)
            : formatDateTime(formData.endDate),
        "userId": isAdmin ? (dataFilter?.userName ? dataFilter.userName : null) : profile.userId,
        "userTypeId": null,
        "shiftId": dataFilter?.shift ? dataFilter.shift : 0,
        "groupId": dataFilter?.userGroup ? dataFilter.userGroup : null,
        "pageNo": page + 1,
        "recordPerPage": pageSize,
        "showTime": formData.showTime,
        "lang": currentLang
    }

    const fetchData = async () => {
        let convertShiftId = bodyRequest?.shiftId;
        if (typeof convertShiftId === 'object' && Array.isArray(convertShiftId)) {
            convertShiftId = parseInt(convertShiftId[0], 10);
        }
        const payload = {
            ...bodyRequest,
            shiftId: convertShiftId,
        };
        try {
            setLoading(true);
            const response = await getListWorkHourSummaryReport(payload);
            // if (payload.shiftId || payload.shiftId === 0) {
            if (response.data.message === 'Successful' || response.data.message === 'Thành công') {
                handleFilter({
                    ...response.data, pagination: {
                        ...response.data.pagination,
                        currentPage: response.data.pagination.currentPage - 1
                    }
                });
                setLoading(false);
            } else {
                toast.error(response.data.message);
            }

            // } else {
            //     handleFilter({
            //         data: [], 
            //         pagination: {
            //             ...response.data.pagination,
            //             currentPage: response.data.pagination.currentPage - 1
            //         }
            //     });
            // }

        } catch (error) {
            setLoading(false);
            if (error.response) {
                if (error.response.status !== 401) {
                    toast.error(t(error?.response.data));
                }
            } else {
                toast.error(t('common.network-timeout'));
            }
            console.error('Error fetching user list:', error);
        } finally {
            setLoading(false);
        }
    };


    useEffect(() => {
        if (bodyRequest?.shiftId || dataFilter?.userName || page || pageSize) {
            fetchData();
        }
    }, [bodyRequest.shiftId, dataFilter.userName, formData, page, pageSize]);


    useEffect(() => {
        getTabName("WorkHourSummaryReport")
    }, []);

    function getCurrentTimestamp() {
        const now = new Date();
        const yyyy = now.getFullYear();
        const MM = String(now.getMonth() + 1).padStart(2, '0');
        const dd = String(now.getDate()).padStart(2, '0');
        const HH = String(now.getHours()).padStart(2, '0');
        const mm = String(now.getMinutes()).padStart(2, '0');
        const ss = String(now.getSeconds()).padStart(2, '0');

        return `${yyyy}${MM}${dd}${HH}${mm}${ss}`;
    }


    const exportCSV = async () => {
        let convertShiftId = bodyRequest?.shiftId;
        if (typeof convertShiftId === 'object' && Array.isArray(convertShiftId)) {
            convertShiftId = parseInt(convertShiftId[0], 10);
        }
        const payload = {
            ...bodyRequest,
            shiftId: convertShiftId,
            formatDate: dateTimeFormat,
            pageNo: totalPages,
        };
        try {
            setLoading(true);
            const response = await exportListWorkHourSummaryReportCSV(payload);

            if (response) {
                const blob = new Blob([response.data], { type: 'application/octet-stream' });
                const url = window.URL.createObjectURL(blob);

                const a = document.createElement('a');
                a.href = url;
                // a.download = 'work-hour-summary-report.csv';
                const filename = `${t("export.WorkHourSummaryReport")}_${getCurrentTimestamp()}.xlsx`;

                a.download = filename;
                // a.download = "WorkHourSummaryReport_" + getCurrentTimestamp() + ".xlsx";
                document.body.appendChild(a);
                a.click();
                a.remove();
            }
        } catch (error) {
            setLoading(false);
            if (error.response) {
                if (error.response.status !== 401) {
                    toast.error(t(error?.response.data));
                }
            } else {
                toast.error(t('common.network-timeout'));
            }
            console.error('Error fetching user list:', error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className='total-work-hours-report'>
            <ReportPageHeader
                onBack={onBack}
                titleKey="common.work-hour-summary-report"
                onExport={exportCSV}
                startDate={formData.startDate}
                endDate={formData.endDate}
                onUpdateSuccess={fetchData}
            />
            <ReportDateFilterRow
                formData={formData}
                setFormData={setFormData}
            />
        </div>
    )
}

export default WorkHourSummaryReport